module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-4-thumb-d249cb70.png";